import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	header: {
		id: 'cross-join-nudges.your-work.header',
		defaultMessage:
			'{collaborators, plural, =0 {Your team is using Confluence} one {{collaborator} is using Confluence} other {{collaborator} and others are using Confluence}}',
		description: 'Title of widget prompting user to join their lisenced Confluence instance',
	},
	description: {
		id: 'cross-join-nudges.your-work.description',
		defaultMessage:
			'Organize team knowledge, capture ideas, and share requirements for your Jira projects.',
		description: 'Description on widget prompting user to join their lisenced Confluence instance',
	},
	joinYourTeam: {
		id: 'cross-join-nudges.your-work.join-your-team',
		defaultMessage: '{collaborators, plural, one {Join {collaborator}} other {Join your team}}',
		description:
			'Primary action button on widget prompting user to join their lisenced Confluence instance',
	},
	remindMeLater: {
		id: 'cross-join-nudges.your-work.remind-me-later',
		defaultMessage: 'Remind me later',
		description:
			'Secondary action button on widget prompting user to join their lisenced Confluence instance',
	},
	notInterested: {
		id: 'cross-join-nudges.your-work.not-interested',
		defaultMessage: 'Not interested',
		description:
			'Secondary action button on widget prompting user to join their lisenced Confluence instance',
	},
	tooltip: {
		id: 'cross-join-nudges.your-work.tooltip',
		defaultMessage:
			"You're seeing this suggestion because you may want to use Confluence to work with the same people you work with in Jira. Your Jira teammates already use Confluence.",
		description: 'Tooltip for widget prompting user to join their lisenced Confluence instance',
	},
	imageAltText: {
		id: 'cross-join-nudges.your-work.image-alt-text',
		defaultMessage: 'Your team collaborating on a document in Confluence',
		description:
			'Image alt text for widget prompting user to join their lisenced Confluence instance',
	},
});
